/**
 * storeContext.ts
 *
 * Thin re-export so all existing services continue to call
 * `getCurrentStoreId()` / `getFreshStoreId()` without any changes.
 *
 * Imports from storeIdResolver.ts (no 'use client') — safe to use
 * in any service file without triggering Next.js client boundary errors.
 */
import { resolveStoreId, clearStoreIdCache } from '@/lib/services/storeIdResolver';

export const getCurrentStoreId = resolveStoreId;
export { clearStoreIdCache };

/**
 * Fresh (no-cache) variant — use this in settings panels and anywhere
 * you need to guarantee the correct store_id after a store switch.
 */
export async function getFreshStoreId(): Promise<string | null> {
  return resolveStoreId(true);
}
